/** Bumped when the shape of `GameState` changes and a save migration is needed. */
export const STATE_VERSION = 1;
/** The identity string for possessing `nodeId`. */
export const puppetIdentity = (nodeId) => `puppet:${nodeId}`;
/** The node id inside a puppet identity, or `null` for `self`. */
export const identityNodeId = (identity) => identity === 'self' ? null : identity.slice('puppet:'.length);
//# sourceMappingURL=state.js.map